import React from "react";
import { InputStyled } from "./style";
var InputLayout = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    return React.createElement(InputStyled, { className: className, style: style }, children);
};
export default InputLayout;
